/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { ICreateSingleSystemSetupParameter } from './ICreateSingleSystemSetupParameter';
import {
    ICreateSingleSystemSetupParameterFromJSON,
    ICreateSingleSystemSetupParameterFromJSONTyped,
    ICreateSingleSystemSetupParameterToJSON,
} from './ICreateSingleSystemSetupParameter';

/**
 * 
 * @export
 * @interface CreateOrUpdateMedicalSystemSetupDto
 */
export interface CreateOrUpdateMedicalSystemSetupDto {
    /**
     * 
     * @type {string}
     * @memberof CreateOrUpdateMedicalSystemSetupDto
     */
    targetSystemEntityId?: string;
    /**
     * 
     * @type {Array<ICreateSingleSystemSetupParameter>}
     * @memberof CreateOrUpdateMedicalSystemSetupDto
     */
    singleSetupParameters: Array<ICreateSingleSystemSetupParameter>;
    /**
     * 
     * @type {string}
     * @memberof CreateOrUpdateMedicalSystemSetupDto
     */
    $type?: CreateOrUpdateMedicalSystemSetupDtoTypeEnum;
}


/**
 * @export
 */
export const CreateOrUpdateMedicalSystemSetupDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedTaskItemComponentDtoCreateOrUpdateMedicalSystemSetupDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.TaskItemComponent.Dto.CreateOrUpdateMedicalSystemSetupDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type CreateOrUpdateMedicalSystemSetupDtoTypeEnum = typeof CreateOrUpdateMedicalSystemSetupDtoTypeEnum[keyof typeof CreateOrUpdateMedicalSystemSetupDtoTypeEnum];


/**
 * Check if a given object implements the CreateOrUpdateMedicalSystemSetupDto interface.
 */
export function instanceOfCreateOrUpdateMedicalSystemSetupDto(value?: unknown): value is CreateOrUpdateMedicalSystemSetupDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(CreateOrUpdateMedicalSystemSetupDtoTypeEnum)[0];
}

export function CreateOrUpdateMedicalSystemSetupDtoFromJSON(json: any): CreateOrUpdateMedicalSystemSetupDto {
    return CreateOrUpdateMedicalSystemSetupDtoFromJSONTyped(json, false);
}

export function CreateOrUpdateMedicalSystemSetupDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateOrUpdateMedicalSystemSetupDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'targetSystemEntityId': !exists(json, 'targetSystemEntityId') ? undefined : json['targetSystemEntityId'],
        'singleSetupParameters': ((json['singleSetupParameters'] as Array<any>).map(ICreateSingleSystemSetupParameterFromJSON)),
        '$type': !exists(json, '$type') ? undefined : json['$type'],
    };
}

export function CreateOrUpdateMedicalSystemSetupDtoToJSON(value?: CreateOrUpdateMedicalSystemSetupDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'targetSystemEntityId': value.targetSystemEntityId,
        'singleSetupParameters': ((value.singleSetupParameters as Array<any>).map(ICreateSingleSystemSetupParameterToJSON)),
        '$type': value.$type,
    });
}

